import { useEffect } from 'react';
import { defaultViewStyle, viewStyleKey } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { StatementStatusType, StatementTypeType } from '../../../../../store/api/statements-api';
import { useStatementsStore } from '../../../../../store/use-statements-store';

export const statementTypeTitleMap: Record<StatementTypeType, string> = {
  VACATION: 'Отпуск',
  SICK: 'Больничный',
};

export const statusTitleMap: Record<StatementStatusType, string> = {
  APPROVED: 'Подтвержден',
  REJECTED: 'Отклонен',
  IDLE: 'Ожидает',
};

export const useStatements = () => {
  const { t } = useLang();
  const { list, fetchStatementList } = useStatementsStore();
  const updateStatementStatus = useModalParams('updateStatementStatus');
  const params = useQueryParams().getQueryParams();
  const viewStyle = params[viewStyleKey] || defaultViewStyle;

  useEffect(() => {
    fetchStatementList({ n: 1000, since_id: 0, is_by_company: true });
  }, []);

  return {
    t,
    list,
    viewStyle,
    updateStatementStatus,
  };
};
